import { ReportingShellControllerBaseConfig } from '../../../base';
import { ChatErrorController } from './chatErrorInterface';
import { ChatErrorViewProps } from './chatErrorProps';

export function createChatErrorController(
    config: ReportingShellControllerBaseConfig
): ChatErrorController {
    return {
        useProps(context, item, props): Omit<ChatErrorViewProps, 'children'> {
            return {
                title: 'Something went wrong',
                description:
                    'An unexpected error occurred while loading the conversaton thread',
                action: {
                    label: 'Go back',
                    button: {
                        onClick() {
                            props.onClear();
                        },
                    },
                },
            };
        },
    };
}
